import { render, staticRenderFns } from "./forgetpassword.vue?vue&type=template&id=69419292&scoped=true&"
import script from "./forgetpassword.vue?vue&type=script&lang=js&"
export * from "./forgetpassword.vue?vue&type=script&lang=js&"
import style0 from "./forgetpassword.vue?vue&type=style&index=0&id=69419292&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69419292",
  null
  
)

export default component.exports